export default __webpack_public_path__ + "602675a367f52c1d4391a2fdf05a8ad3.svg";